<template>
  <div>
    <div class="input-group">
      <input
        type="text"
        @keydown="handleInput"
        v-model="input"
        ref="input"
        class="form-control"
        :placeholder="placeholder"
      />
      <button class="btn btn-sm btn-primary scan-button" @click="toggleScanner">Scan</button>
    </div>
    <StreamBarcodeReader @decode="onDecode" class="scanner" v-if="scannerIsVisible"></StreamBarcodeReader>
  </div>
</template>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { searchMixin } from '@/mixins/searchMixin'

export default {
  data() {
    return {
      input: '',
      scannerIsVisible: false,
      result: null
    }
  },
  props: ['placeholder'],
  components: { StreamBarcodeReader },
  mixins: [searchMixin],
  methods: {
    handleInput: function(e) {
      if (e.key === 'Enter') {
        this.query(this.input)
        this.input = ''
      }
    },
    onDecode: function(result) {
      this.scannerIsVisible = false
      this.query(result)
    },
    toggleScanner: function() {
      this.scannerIsVisible = !this.scannerIsVisible
    }
  }
}
</script>

<style lang="scss" scoped>
.scan-button {
  z-index: 1000;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;

  padding-left: 3.5rem;
  padding-right: 1rem;
  font-weight: bold;

  background-image: url(../assets/barcode-scan.svg);
  background-size: 2rem;
  background-position: 0.75rem center;
  background-repeat: no-repeat;
}
</style>
